import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { BaseServices } from './../../kuba.services';
import { TypeOfWork } from './../../time-table/models/timetable';
import {
  BusinessDepartment,
  Employee,
  EmployeeDocument,
  EmployeePosition,
  EmployeeType
} from './../models/employee';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { SKIP_ERROR_TOAST } from 'src/app/shared/http-context-tokens';
import { map } from 'rxjs/operators';

@Injectable()
export class EmployeeServices {
  item: Object;
  ses: string;
  constructor(private http: HttpClient) {}

  getAllFunctions() {
    return this.http
      .get(environment.BASE_URL + '/contactfunctions/contactFunctions/').pipe(rxjsmap((result: any) => result));
  }

  deleteDepartment(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/departmentdelete/' + id).pipe(rxjsmap(result => result));
  }

  // List all employees (non-paginated)
  list(id: number) {
    return this.http
      .get(environment.BASE_URL + '/employees/' + id).pipe(rxjsmap((result: any) => result));
  }

  // Get paginated employee list
  getPagedList(businessId: number, filter: any): Observable<any> {
    return this.http
      .post<any>(environment.BASE_URL + '/employees/' + businessId + '/paged', filter).pipe(rxjsmap(result => result));
  }

  // Get paginated employee list for Admin role
  getPagedAdminList(filter: any): Observable<any> {
    return this.http
      .post<any>(environment.BASE_URL + '/admin/employees/paged', filter).pipe(rxjsmap(result => result));
  }

  // Get paginated employee list for Portal role
  getPagedPortalList(portalId: number, filter: any): Observable<any> {
    return this.http
      .post<any>(environment.BASE_URL + '/portal/' + portalId + '/employees/paged', filter).pipe(rxjsmap(result => result));
  }

  // List all employees
  portalList(userId: number) {
    return this.http
      .get(environment.BASE_URL + '/portalemployees/' + userId).pipe(rxjsmap((result: any) => result));
  }

  UpdateUser(id: number, data: any) {
    return this.http
      .put(environment.BASE_URL + '/user/' + id, data).pipe(rxjsmap(result => result));
  }

  getActiveEmployees(id: number) {
    return this.http
      .get(environment.BASE_URL + '/activeemployees/' + id).pipe(rxjsmap(result => result));
  }

  // retrive an employee for editing and View
  getById(id: any) {
    return this.http
      .get(environment.BASE_URL + '/employee/' + id).pipe(rxjsmap((result: any) => result));
  }

  getSubDepartmentByEmployee(employeeId: number) {
    return this.http
      .get(environment.BASE_URL + '/businesssubdepartment/' + employeeId).pipe(rxjsmap((result: any) => result));
  }

  getUsersById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/user/' + id).pipe(rxjsmap(result => result));
  }

  getUsersInfoById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/userinfo/' + id).pipe(rxjsmap((result: any) => result));
  }

  // add employee to list
  /**
   * Creates an employee. Uses SKIP_ERROR_TOAST so the form can report a refused
   * creation, such as the license limit being reached, in its own words.
   * @param data The employee to create
   * @returns Observable of the created employee
   */
  add(data: any) {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/employee', body,
        { context: new HttpContext().set(SKIP_ERROR_TOAST, true) })
      .pipe(rxjsmap(result => result));
  }

  // Active and Inactive the Employee
  statusUpdate(id: number, status: any) {
    return this.http
      .put(`${environment.BASE_URL}/employee/${id}/${status}`, null).pipe(rxjsmap(result => result));
  }

  // updating employee list
  update(id: number, ExistingEmployee: Employee) {
    return this.http
      .put(environment.BASE_URL + '/employee/' + id, ExistingEmployee).pipe(rxjsmap(result => result));
  }

  updateDoc(data: EmployeeDocument) {
    return this.http
      .put(environment.BASE_URL + '/employee/' + data, {}).pipe(rxjsmap(result => result));
  }

  // Delete equipment from list
  deleteEmployee(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employee/' + Id)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }

  // multiple delete
  deleteMultipleEmployee(ids: any) {
    return this.http
      .put(environment.BASE_URL + '/employees', ids).pipe(rxjsmap(result => result));
  }

  // bind employee type
  getAllByType(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/employeetypes/' + Id).pipe(rxjsmap(result => <EmployeeType[]>result));
  }

  // update employee type
  updateType(existingCategory: EmployeeType) {
    return this.http
      .put(
        environment.BASE_URL + '/employeetype/' + existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // adding employee Type
  createType(newCategory: EmployeeType) {
    return this.http
      .post(environment.BASE_URL + '/employeetype', JSON.stringify(newCategory)).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // adding employee Type
  getemployeename() {
    return this.http
      .post(
        environment.BASE_URL + '/employeename/' + BaseServices.BusinessId,
        {}
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // deleting employee type
  deleteType(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeetype/' + id).pipe(rxjsmap(result => result));
  }

  // delete employe image
  deleteEmployeImage(empId: number, userId: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeeImage/' + empId + '/' + userId).pipe(rxjsmap(result => result));
  }

  deleteSubDepartment(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/delete/subdepartment/' + id).pipe(rxjsmap(result => result));
  }

  deletePosition(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeeposition/' + id).pipe(rxjsmap(result => result));
  }

  // bind employee position
  getAllByPosition(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/employeepositions/' + Id).pipe(rxjsmap((result: any) => {
        return result;
      }));
  }

  // update employee position
  updatePosition(existingCategory: EmployeePosition) {
    return this.http
      .put(
        environment.BASE_URL + '/employeeposition/' + existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // adding employee position
  createPosition(newCategory: EmployeePosition) {
    return this.http
      .post(
        environment.BASE_URL + '/employeeposition',
        JSON.stringify(newCategory)
      ).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  // check user name
  getUserName(userName: string) {
    return this.http
      .get(environment.BASE_URL + '/check-username/' + userName).pipe(rxjsmap(result => result));
  }

  // check user name status: Available | Active | Inactive | Deleted
  getUserNameStatus(userName: string) {
    return this.http
      .get(environment.BASE_URL + '/check-username-status/' + userName, { responseType: 'text' }).pipe(rxjsmap((result: string) => (result || '').replace(/"/g, '').trim()));
  }

  // check user name With Application
  getUserNameWithAppId(AppId: number, userName: string) {
    return this.http
      .get(
        environment.BASE_URL + '/check-username-id/' + AppId + '/' + userName
      ).pipe(rxjsmap(result => result));
  }

  // check email name
  getEmail(AppId: number, email: string) {
    return this.http
      .get(
        environment.BASE_URL + '/check-email-employee/' + AppId + '/' + email
      ).pipe(rxjsmap(result => result));
  }

  // update employee department
  updateDept(existingCategory: Employee): Observable<BusinessDepartment> {
    return this.http
      .put(
        environment.BASE_URL + '/department/' + existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap((response: BusinessDepartment) => {
        return response;
      }));
  }

  // adding employee department
  createDept(newCategory: Employee): Observable<BusinessDepartment> {
    return this.http
      .post(environment.BASE_URL + '/department', JSON.stringify(newCategory)).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  createSubDept(newSubDept: Employee) {
    return this.http
      .post(environment.BASE_URL + '/createsubdepartment', newSubDept).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }
  // timttable list

  getAllTimetableByBusinessId(id: number) {
    return this.http
      .get(environment.BASE_URL + '/business-timetables/' + id).pipe(rxjsmap((result: any) => (result ? result : null)));
  }

  getTimeTableByEmployeeId(id: number) {
    return this.http
      .get(environment.BASE_URL + '/timetablebyemployee/' + id).pipe(rxjsmap((result: any) => (result ? result : null)));
  }

  // create timetable
  create(data: any) {
    return this.http
      .post(environment.BASE_URL + '/timetable/', data)
      .toPromise()
      .then((response: any) => {
        return response;
      });
  }

  // delete timetable
  deleteTimetable(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/timetable/' + id).pipe(rxjsmap(result => result));
  }

  // bind type dropdown
  getType(id: number) {
    return this.http
      .get(environment.BASE_URL + '/typeofworks/' + id).pipe(rxjsmap(result => <TypeOfWork[]>result));
  }

  // bind project dropdown
  getAllProject(Id: number) {
    return this.http
      .get(environment.BASE_URL + '/project/getall/' + Id).pipe(rxjsmap(result => result));
  }

  // add Private document
  addDoc(data: any) {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/employeedocument', body).pipe(rxjsmap(this.extractData));
  }

  private extractData(res: any) {
    let body = res; // return body || {};
    return <Employee[]>res;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getallDocuments(eid: number) {
    return this.http
      .get(environment.BASE_URL + '/employeedocuments/' + eid).pipe(rxjsmap(result => result));
  }

  getAllSubDepartments(id: Array<number>) {
    const businessId = BaseServices.BusinessId;
    const params = [
      ...(id?.map(i => `departmentIds=${i}`) || []),
      businessId ? `businessId=${businessId}` : ''
    ].filter(Boolean).join('&');
    const url = `${environment.BASE_URL}/subdepartments${params ? `?${params}` : ''}`;

    return this.http.get(url).pipe(rxjsmap(result => result));
  }

  getAssignedDepartments(id: Array<number>) {
    const params = id.map(i => `departmentIds=${i}`).join('&');
    return this.http
      .get(`${environment.BASE_URL}/assigneddepartments?${params}`).pipe(rxjsmap(result => result));
  }

  deleteDocument(id: number) {
    return this.http
      .delete(environment.BASE_URL + '/employeedocument/' + id).pipe(rxjsmap(result => result));
  }

  getEmployeeUser(featureKey: number) {
    return this.http
      .get(environment.BASE_URL + '/employeeUser/' + featureKey).pipe(rxjsmap(result => result));
  }

  save(employeeId: number, document: any) {
    return this.http
      .post(
        environment.BASE_URL + '/employee/' + employeeId + '/private-doc',
        document
      ).pipe(rxjsmap(result => result));
  }
  
  listDoc(employeeId: number) {
    return this.http
      .get(environment.BASE_URL + '/employee/' + employeeId + '/common-docs').pipe(rxjsmap((response: any) => {
        if (response.status === 200) {
          let data = response.data || [];
          data.forEach((d: any) => {
            d.CreatedOn = new Date(d.CreatedOn);
            d.ModifiedOn = new Date(d.ModifiedOn);
          });
          response.data = data;
          return response;
        } else {
          return response || {};
        }
      })).pipe(rxjscatchError(error => {
        return [];
      }));
  }

  /**
   * delete documents
   * @param Id {any}
   */
  deleteEmployeeDocument(Id: any) {
    return this.http
      .delete(environment.BASE_URL + '/delete-employee-document/' + Id).pipe(rxjsmap(result => result));
  }

  reportGenerate(businessId: number, cultureInfo: string, ReportJson: any) {
    let dynamicType = 'application/pdf';
    let myData = { data: ReportJson };
    let url = `${environment.BASE_URL}/export-commondetailslist/${businessId}/${cultureInfo}`;
    return this.http
      .post(url, myData, { responseType: 'blob' })
      .pipe(rxjsmap(blob => new Blob([blob], { type: dynamicType })));
  }

  approveTimeTable(timeTableId: any) {
    return this.http
      .put(environment.BASE_URL + '/approvetimetable', timeTableId).pipe(rxjsmap((response: any) => {
        return response;
      }));
  }

  currentUserTOCStatus(userId: number, IsTOCApproved: boolean) {
    return this.http
      .put(
        `${environment.BASE_URL}/current-user/${userId}/${IsTOCApproved}`,
        null,
        { responseType: 'blob' }
      ).pipe(rxjsmap(result => result));
  }

  getUserByEmployeeId(empId: number) {
    return this.http
      .get(`${environment.BASE_URL}/GetUserByEmployee/${empId}`).pipe(rxjsmap(result => result));
  }

  /**
   * Checks if a sub department is in use
   * @param Id {number}
   * @param businessId {number}
   */
  checkSubDeptById(id: number, businessId: number) {
    return this.http
      .get(`${environment.BASE_URL}/check/subdepartment/${id}/${businessId}`).pipe(rxjsmap(result => result));
  }
}
